import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn } from "@reduxjs/toolkit/query/react";

import { SUPERBLOCKS_UI_API_ENDPOINT_BASE_URL } from "env";
import { getDashboardRequestHeaders } from "store/utils/requestHeaders";

const baseQueryWithHeaders: BaseQueryFn = async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: SUPERBLOCKS_UI_API_ENDPOINT_BASE_URL || "/api/",
  });

  const headers = await getDashboardRequestHeaders();

  // Merge the prepared headers with any existing headers in the query
  let mergedArgs: any;
  if (typeof args === "string") {
    mergedArgs = { url: args, headers };
  } else {
    mergedArgs = {
      ...args,
      headers: new Headers({ ...Object.fromEntries(headers), ...args.headers }),
    };
  }

  return baseQuery(mergedArgs, api, extraOptions);
};

// Tag type constants
const ApplicationsTag = "Applications";
export const BuilderSeatsTag = "BuilderSeats" as const;
const PlanSummaryTag = "PlanSummary" as const;
const AutoTopupConfigTag = "AutoTopupConfig" as const;
export const BranchTag = "Branch" as const;
export const GitLabPersonalAccessTokenTag = "GitLabPersonalAccessToken";
export const GitLabProjectsTag = "GitLabProjects";
export const RepositoryTag = "Repository" as const;
export const RoleTag = "Role";
const WorkflowsAndScheduledJobsTag = "WorkflowsAndScheduledJobs";

export const FactsTag = "Facts" as const;
const NotificationsTag = "Notifications" as const;
const NotificationsUnreadCountTag = "NotificationsUnreadCount" as const;
export const SpendAlertsTag = "SpendAlerts" as const;
const UsageDailyTag = "UsageDaily" as const;
export const UsageCreditLimitsTag = "UserCreditLimits" as const;
const UsageRecordsTag = "UsageRecords" as const;
export const UsersTag = "Users" as const;

export const reduxApiSlice = createApi({
  reducerPath: "reduxApi", // not using the default "api" name because we have an entity called api
  baseQuery: baseQueryWithHeaders,
  endpoints: (builder) => ({}),
  tagTypes: [
    ApplicationsTag,
    BuilderSeatsTag,
    PlanSummaryTag,
    AutoTopupConfigTag,
    BranchTag,
    FactsTag,
    GitLabPersonalAccessTokenTag,
    GitLabProjectsTag,
    NotificationsTag,
    NotificationsUnreadCountTag,
    RepositoryTag,
    RoleTag,
    SpendAlertsTag,
    UsageCreditLimitsTag,
    UsageDailyTag,
    UsageRecordsTag,
    UsersTag,
    WorkflowsAndScheduledJobsTag,
  ],
});
